import classNames from 'classnames';

import Metar from './Metar';

const calc = value => `calc(${value}% - 2em + 2px)`;

const Airport = ({icao, name, metars, active, x, y, onClick, onMouseEnter, onMouseLeave}) => (
    <div className={classNames('map-pin', 'map-pin-airport', 'icon' ,'icon-pin', {active})}
         onClick={onClick}
         onMouseEnter={onMouseEnter}
         onMouseLeave={onMouseLeave}
         style={{left: `${x}%`, top: `${y}%`}}>
        <div className="map-pin-airport-popup"
             style={{transform: `translate(-${x}%, 0)`}}>
            <span className="tail" style={{left: calc(x)}} />
            <p className="title">{icao} | {name}</p>
            <Metar metars={metars} />
        </div>
    </div>
);

export default Airport;
